const activateCookieBanner = () => {
	const cookieOpenButtons = document.querySelectorAll('[cookie-activate]');
	if (cookieOpenButtons) {
		cookieOpenButtons.forEach((button) => {
			button.addEventListener('click', () => {
				var cBanner = document.querySelector('.cc-revoke');
				if (cBanner) {
					cBanner.click();
				}
			});
		});
	}
};

document.addEventListener('DOMContentLoaded', activateCookieBanner);
